import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.svg';

// Premium Inline SVG Icons (Zero Dependencies, Crisp Rendering)
const IconMapPin = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

const IconMail = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);

const IconPhone = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>
);

const IconWhatsApp = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.297-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const IconFacebook = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const IconInstagram = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const quickLinks = [
  { path: "/", display: "Home" },
  { path: "/about", display: "About Us" },
  { path: "/services", display: "Services " },
  { path: "/gallery", display: "Gallery" },
];

// const serviceLinks = [
//   { path: "/services", display: "Visa Assistance" },
//   { path: "/services", display: "Flight Booking" },
//   { path: "/services", display: "Hotel Reservations" },
//   { path: "/services", display: "Corporate Travel" },
// ];

const legalLinks = [
  { path: "/privacy", display: "Privacy Policy" },
  { path: "/terms", display: "Terms of Service" },
  { path: "/cookies", display: "Cookie Policy" },
];

const Footer = () => {
  const year = new Date().getFullYear();
  const WHATSAPP_URL = "https://wa.me/2348077854009";
  const FACEBOOK_URL = "https://www.facebook.com/OscarGlobalIntl";
  const INSTAGRAM_URL = "https://www.instagram.com/oscarglobalintl";

  return (
    <>
      <style>{`
        .oscar-footer * { box-sizing: border-box; margin: 0; padding: 0; }
        
        .oscar-footer {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          background: #050B14;
          color: #CBD5E1;
          padding: 5rem 0 2rem;
          position: relative;
          overflow: hidden;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        /* Subtle premium ambient glow */
        .oscar-footer::after {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: radial-gradient(circle at 10% 20%, rgba(13, 148, 136, 0.06), transparent 40%),
                      radial-gradient(circle at 90% 80%, rgba(139, 92, 246, 0.04), transparent 40%);
          pointer-events: none;
          z-index: 0;
        }

        /* Top border accent */
        .oscar-footer::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(13, 148, 136, 0.5), rgba(139, 92, 246, 0.5), transparent);
          z-index: 2;
        }

        .footer-container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 2rem;
          position: relative;
          z-index: 1;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
          gap: 3rem;
          margin-bottom: 4rem;
        }

        /* Brand Column */
        .footer-brand { display: flex; flex-direction: column; gap: 1.5rem; }
        
        .footer-logo { 
          display: flex; 
          align-items: center; 
          gap: 0.75rem; 
          text-decoration: none; 
          transition: opacity 0.2s;
        }
        .footer-logo:hover { opacity: 0.8; }
        .footer-logo img { height: 36px; filter: brightness(0) invert(1); }
        .footer-logo span { 
          font-size: 1.25rem; 
          font-weight: 700; 
          color: #F8FAFC; 
          letter-spacing: -0.02em; 
        }
        
        .footer-tagline { 
          font-size: 0.95rem; 
          color: #94A3B8; 
          line-height: 1.7; 
          max-width: 280px; 
        }

        /* Social Icons */
        .social-grid { display: flex; gap: 0.75rem; }
        .social-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.04);
          border: 1px solid rgba(255, 255, 255, 0.06);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #94A3B8;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          text-decoration: none;
        }
        .social-icon:hover {
          background: rgba(13, 148, 136, 0.15);
          border-color: rgba(13, 148, 136, 0.4);
          color: #2DD4BF;
          transform: translateY(-3px);
        }

        /* Link Columns */
        .footer-col-title {
          font-size: 0.8rem;
          font-weight: 600;
          color: #F8FAFC;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          margin-bottom: 1.5rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
        .footer-col-title::before {
          content: '';
          width: 12px;
          height: 2px;
          background: #0D9488;
          border-radius: 2px;
        }

        .footer-links { list-style: none; display: flex; flex-direction: column; gap: 0.85rem; }
        .footer-link {
          color: #94A3B8;
          text-decoration: none;
          font-size: 0.95rem;
          font-weight: 400;
          transition: all 0.2s ease;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
        }
        .footer-link:hover { color: #F8FAFC; transform: translateX(4px); }

        /* Contact Column */
        .contact-item {
          display: flex;
          gap: 1rem;
          margin-bottom: 1.25rem;
          align-items: flex-start;
        }
        .contact-icon {
          width: 36px;
          height: 36px;
          border-radius: 8px;
          background: rgba(13, 148, 136, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #2DD4BF;
          flex-shrink: 0;
          margin-top: 2px;
        }
        .contact-text { font-size: 0.95rem; color: #CBD5E1; line-height: 1.6; }
        .contact-text a { color: inherit; text-decoration: none; transition: color 0.2s; }
        .contact-text a:hover { color: #2DD4BF; }

        /* Bottom Bar */
        .footer-bottom {
          padding-top: 2rem;
          border-top: 1px solid rgba(255, 255, 255, 0.06);
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 1.5rem;
        }
        .copyright { font-size: 0.875rem; color: #64748B; }
        .legal-links { display: flex; gap: 1.5rem; }
        .legal-link {
          font-size: 0.875rem;
          color: #64748B;
          text-decoration: none;
          transition: color 0.2s;
        }
        .legal-link:hover { color: #CBD5E1; }

        /* Accessibility Focus States */
        .footer-link:focus-visible, 
        .social-icon:focus-visible, 
        .legal-link:focus-visible,
        .footer-logo:focus-visible {
          outline: 2px solid #0D9488;
          outline-offset: 4px;
          border-radius: 4px;
        }

        /* Responsive Breakpoints */
        @media (max-width: 1024px) {
          .footer-grid { grid-template-columns: 1fr 1fr; gap: 3rem 2rem; }
        }
        @media (max-width: 640px) {
          .oscar-footer { padding: 4rem 0 2rem; }
          .footer-grid { grid-template-columns: 1fr; gap: 2.5rem; }
          .footer-bottom { flex-direction: column; text-align: center; gap: 1rem; }
          .legal-links { justify-content: center; flex-wrap: wrap; }
        }
      `}</style>

      <footer className="oscar-footer">
        <div className="footer-container">
          <div className="footer-grid">
            {/* Brand & Social */}
            <div className="footer-brand">
              <Link to="/" className="footer-logo">
                <img src={logo} alt="Oscar Global" />
                {/* <span>Oscar Global</span> */}
              </Link>
              <p className="footer-tagline">
                Personalized travel experiences, seamless planning, breath taking destinations and reliability.
              </p>
              <div className="social-grid">
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Contact on WhatsApp">
                  <IconWhatsApp />
                </a>
                <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Follow on Facebook">
                  <IconFacebook />
                </a>
                <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Follow on Instagram">
                  <IconInstagram />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="footer-col-title">Explore</h4>
              <ul className="footer-links">
                {quickLinks.map((item, i) => (
                  <li key={i}>
                    <Link to={item.path} className="footer-link">{item.display}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            {/* <div>
              <h4 className="footer-col-title">Services</h4>
              <ul className="footer-links">
                {serviceLinks.map((item, i) => (
                  <li key={i}>
                    <Link to={item.path} className="footer-link">{item.display}</Link>
                  </li>
                ))}
              </ul>
            </div> */}

            {/* Contact Info */}
            <div>
              <h4 className="footer-col-title">Reach Us</h4>
              <div className="contact-item">
                <div className="contact-icon"><IconMapPin /></div>
                <div className="contact-text">
                  M3 Los Angeles Mall,<br />
                  Ahmadu Bello Way, Mabushi,<br />
                  Abuja, Nigeria
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon"><IconMail /></div>
                <div className="contact-text">
                  <a href="mailto:oscarglobaltt@gmail.com">oscarglobaltt@gmail.com</a>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon"><IconPhone /></div>
                <div className="contact-text">
                  <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                    +234 806 807 9807
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="footer-bottom">
            <p className="copyright">
              &copy; {year} Oscar Global Travel. All rights reserved.
            </p>
            <div className="legal-links">
              {legalLinks.map((item, i) => (
                <Link key={i} to={item.path} className="legal-link">
                  {item.display}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;















// import React from 'react';
// import { Link } from 'react-router-dom';
// import logo from '../../assets/images/logo.svg';

// // Premium Inline SVG Icons (Zero Dependencies, Crisp Rendering)
// const IconMapPin = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
//     <circle cx="12" cy="10" r="3"></circle>
//   </svg>
// );

// const IconMail = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
//     <polyline points="22,6 12,13 2,6"></polyline>
//   </svg>
// );

// const IconPhone = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
//   </svg>
// );

// const IconWhatsApp = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//     <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.297-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
//   </svg>
// );

// const IconFacebook = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//     <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
//   </svg>
// );

// const IconInstagram = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//     <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
//   </svg>
// );

// const quickLinks = [
//   { path: "/", display: "Home" },
//   { path: "/about", display: "About Us" },
//   { path: "/tours", display: "Tour Packages" },
//   { path: "/gallery", display: "Gallery" },
// ];

// const serviceLinks = [
//   { path: "/services", display: "Visa Assistance" },
//   { path: "/services", display: "Flight Booking" },
//   { path: "/services", display: "Hotel Reservations" },
//   { path: "/services", display: "Corporate Travel" },
// ];

// const legalLinks = [
//   { path: "/privacy", display: "Privacy Policy" },
//   { path: "/terms", display: "Terms of Service" },
//   { path: "/cookies", display: "Cookie Policy" },
// ];

// const Footer = () => {
//   const year = new Date().getFullYear();
//   const WHATSAPP_URL = "https://wa.me/2348077854009";
//   const FACEBOOK_URL = "https://www.facebook.com/OscarGlobalIntl";

//   return (
//     <>
//       <style>{`
//         .oscar-footer * { box-sizing: border-box; margin: 0; padding: 0; }
        
//         .oscar-footer {
//           font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
//           background: #050B14;
//           color: #CBD5E1;
//           padding: 5rem 0 2rem;
//           position: relative;
//           overflow: hidden;
//           -webkit-font-smoothing: antialiased;
//           -moz-osx-font-smoothing: grayscale;
//         }

//         /* Subtle premium ambient glow */
//         .oscar-footer::after {
//           content: '';
//           position: absolute;
//           top: 0; left: 0; right: 0; bottom: 0;
//           background: radial-gradient(circle at 10% 20%, rgba(13, 148, 136, 0.06), transparent 40%),
//                       radial-gradient(circle at 90% 80%, rgba(139, 92, 246, 0.04), transparent 40%);
//           pointer-events: none;
//           z-index: 0;
//         }

//         /* Top border accent */
//         .oscar-footer::before {
//           content: '';
//           position: absolute;
//           top: 0; left: 0; right: 0;
//           height: 1px;
//           background: linear-gradient(90deg, transparent, rgba(13, 148, 136, 0.5), rgba(139, 92, 246, 0.5), transparent);
//           z-index: 2;
//         }

//         .footer-container {
//           max-width: 1280px;
//           margin: 0 auto;
//           padding: 0 2rem;
//           position: relative;
//           z-index: 1;
//         }

//         .footer-grid {
//           display: grid;
//           grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
//           gap: 3rem;
//           margin-bottom: 4rem;
//         }

//         /* Brand Column */
//         .footer-brand { display: flex; flex-direction: column; gap: 1.5rem; }
        
//         .footer-logo { 
//           display: flex; 
//           align-items: center; 
//           gap: 0.75rem; 
//           text-decoration: none; 
//           transition: opacity 0.2s;
//         }
//         .footer-logo:hover { opacity: 0.8; }
//         .footer-logo img { height: 36px; filter: brightness(0) invert(1); }
//         .footer-logo span { 
//           font-size: 1.25rem; 
//           font-weight: 700; 
//           color: #F8FAFC; 
//           letter-spacing: -0.02em; 
//         }
        
//         .footer-tagline { 
//           font-size: 0.95rem; 
//           color: #94A3B8; 
//           line-height: 1.7; 
//           max-width: 280px; 
//         }

//         /* Social Icons */
//         .social-grid { display: flex; gap: 0.75rem; }
//         .social-icon {
//           width: 40px;
//           height: 40px;
//           border-radius: 10px;
//           background: rgba(255, 255, 255, 0.04);
//           border: 1px solid rgba(255, 255, 255, 0.06);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: #94A3B8;
//           transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
//           text-decoration: none;
//         }
//         .social-icon:hover {
//           background: rgba(13, 148, 136, 0.15);
//           border-color: rgba(13, 148, 136, 0.4);
//           color: #2DD4BF;
//           transform: translateY(-3px);
//         }

//         /* Link Columns */
//         .footer-col-title {
//           font-size: 0.8rem;
//           font-weight: 600;
//           color: #F8FAFC;
//           text-transform: uppercase;
//           letter-spacing: 0.1em;
//           margin-bottom: 1.5rem;
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }
//         .footer-col-title::before {
//           content: '';
//           width: 12px;
//           height: 2px;
//           background: #0D9488;
//           border-radius: 2px;
//         }

//         .footer-links { list-style: none; display: flex; flex-direction: column; gap: 0.85rem; }
//         .footer-link {
//           color: #94A3B8;
//           text-decoration: none;
//           font-size: 0.95rem;
//           font-weight: 400;
//           transition: all 0.2s ease;
//           display: inline-flex;
//           align-items: center;
//           gap: 0.5rem;
//         }
//         .footer-link:hover { color: #F8FAFC; transform: translateX(4px); }

//         /* Contact Column */
//         .contact-item {
//           display: flex;
//           gap: 1rem;
//           margin-bottom: 1.25rem;
//           align-items: flex-start;
//         }
//         .contact-icon {
//           width: 36px;
//           height: 36px;
//           border-radius: 8px;
//           background: rgba(13, 148, 136, 0.1);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: #2DD4BF;
//           flex-shrink: 0;
//           margin-top: 2px;
//         }
//         .contact-text { font-size: 0.95rem; color: #CBD5E1; line-height: 1.6; }
//         .contact-text a { color: inherit; text-decoration: none; transition: color 0.2s; }
//         .contact-text a:hover { color: #2DD4BF; }

//         /* Bottom Bar */
//         .footer-bottom {
//           padding-top: 2rem;
//           border-top: 1px solid rgba(255, 255, 255, 0.06);
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           flex-wrap: wrap;
//           gap: 1.5rem;
//         }
//         .copyright { font-size: 0.875rem; color: #64748B; }
//         .legal-links { display: flex; gap: 1.5rem; }
//         .legal-link {
//           font-size: 0.875rem;
//           color: #64748B;
//           text-decoration: none;
//           transition: color 0.2s;
//         }
//         .legal-link:hover { color: #CBD5E1; }

//         /* Accessibility Focus States */
//         .footer-link:focus-visible, 
//         .social-icon:focus-visible, 
//         .legal-link:focus-visible,
//         .footer-logo:focus-visible {
//           outline: 2px solid #0D9488;
//           outline-offset: 4px;
//           border-radius: 4px;
//         }

//         /* Responsive Breakpoints */
//         @media (max-width: 1024px) {
//           .footer-grid { grid-template-columns: 1fr 1fr; gap: 3rem 2rem; }
//         }
//         @media (max-width: 640px) {
//           .oscar-footer { padding: 4rem 0 2rem; }
//           .footer-grid { grid-template-columns: 1fr; gap: 2.5rem; }
//           .footer-bottom { flex-direction: column; text-align: center; gap: 1rem; }
//           .legal-links { justify-content: center; flex-wrap: wrap; }
//         }
//       `}</style>

//       <footer className="oscar-footer">
//         <div className="footer-container">
//           <div className="footer-grid">
//             {/* Brand & Social */}
//             <div className="footer-brand">
//               <Link to="/" className="footer-logo">
//                 <img src={logo} alt="Oscar Global" />
//                 <span>Oscar Global</span>
//               </Link>
//               <p className="footer-tagline">
//                 Curated travel experiences, tailored to your journey. Seamless planning, secure bookings, and unforgettable destinations.
//               </p>
//               <div className="social-grid">
//                 <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Contact on WhatsApp">
//                   <IconWhatsApp />
//                 </a>
//                 <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Follow on Facebook">
//                   <IconFacebook />
//                 </a>
//                 <a href="#" className="social-icon" aria-label="Follow on Instagram">
//                   <IconInstagram />
//                 </a>
//               </div>
//             </div>

//             {/* Quick Links */}
//             <div>
//               <h4 className="footer-col-title">Explore</h4>
//               <ul className="footer-links">
//                 {quickLinks.map((item, i) => (
//                   <li key={i}>
//                     <Link to={item.path} className="footer-link">{item.display}</Link>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Services */}
//             <div>
//               <h4 className="footer-col-title">Services</h4>
//               <ul className="footer-links">
//                 {serviceLinks.map((item, i) => (
//                   <li key={i}>
//                     <Link to={item.path} className="footer-link">{item.display}</Link>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Contact Info */}
//             <div>
//               <h4 className="footer-col-title">Reach Us</h4>
//               <div className="contact-item">
//                 <div className="contact-icon"><IconMapPin /></div>
//                 <div className="contact-text">
//                   M3 Los Angeles Mall,<br />
//                   Ahmadu Bello Way, Mabushi,<br />
//                   Abuja, Nigeria
//                 </div>
//               </div>
//               <div className="contact-item">
//                 <div className="contact-icon"><IconMail /></div>
//                 <div className="contact-text">
//                   <a href="mailto:oscarglobaltt@gmail.com">oscarglobaltt@gmail.com</a>
//                 </div>
//               </div>
//               <div className="contact-item">
//                 <div className="contact-icon"><IconPhone /></div>
//                 <div className="contact-text">
//                   <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
//                     +234 807 785 4009
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Bottom Bar */}
//           <div className="footer-bottom">
//             <p className="copyright">
//               &copy; {year} Oscar Global Travel. All rights reserved.
//             </p>
//             <div className="legal-links">
//               {legalLinks.map((item, i) => (
//                 <Link key={i} to={item.path} className="legal-link">
//                   {item.display}
//                 </Link>
//               ))}
//             </div>
//           </div>
//         </div>
//       </footer>
//     </>
//   );
// };

// export default Footer;